import React, { useContext, useState, useEffect } from 'react'
import EmployeeForm from '@/product/components/species/employee/EmployeeForm'
import { handleRedirectInternal } from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import { useHistory } from 'react-router'
import * as Yup from 'yup'

const EmployeeManage = (props) => {
    const commonContext = useContext(CommonContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const data = props.data
    const { user } = authContext
    const { USStates, allCountries, allStates } = commonContext
    const { allConfigurationVariables, allLocations } = customCommonContext
    const [initialValues, setInitialValues] = useState({
        id: 0,
        emp_email: '',
        confirm_email: '',
        emp_firstname: '',
        emp_lastname: '',
        emp_address1: '',
        emp_phone: '',
        emp_type: 'employee',
        emp_city: '',
        emp_state: global.defaultState,
        emp_country: global.defaultCountry,
        emp_zip: '',
        emp_permissions: [],
        emp_location: [],
        select_all: [],
    })
    const [passwordInitialValues, setPasswordInitialValues] = useState({
        id: 0,
        change_password: true,
        password: '',
        confirm_password: '',
    })
    const resetFrom = () => {
        setInitialValues({
            id: 0,
            emp_email: '',
            confirm_email: '',
            emp_firstname: '',
            emp_lastname: '',
            emp_address1: '',
            emp_phone: '',
            emp_type: 'employee',
            emp_city: '',
            emp_state: global.defaultState,
            emp_country: global.defaultCountry,
            emp_zip: '',
            emp_permissions: [],
            emp_location: [],
        })
        setPasswordInitialValues({
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        })
        // formik.handleReset()
        // formikPassword.handleReset()
        // setIsLoading(false)
    }
    const employeeFunctionEdit = (single_employee) => {
        if (single_employee?.record && props?.match?.params?.id) {
            const user = single_employee.record
            setInitialValues({
                id: props?.match?.params?.id
                    ? parseInt(props?.match?.params?.id)
                    : 0,
                emp_email: user.emp_email,
                emp_firstname: user.emp_firstname,
                emp_lastname: user.emp_lastname,
                emp_address1: user.emp_address1,
                emp_phone: user.emp_phone || '',
                emp_type: user.emp_type ? user.emp_type : 'employee',
                emp_city: user.emp_city,
                emp_state: user.emp_state
                    ? user.emp_state
                    : global.defaultState,
                emp_country: user.emp_country
                    ? user.emp_country
                    : global.defaultCountry,
                emp_zip: user.emp_zip,
                emp_permissions:
                    user?.emp_permissions && user.emp_permissions.length
                        ? user.emp_permissions.split(',')
                        : [],
                emp_location: user?.emp_location?.length
                    ? user.emp_location.split(',')
                    : [],
            })
            //setReload(!reload)
        } else {
            resetFrom()
        }
        //setIsLoading(false)
    }

    const permission = [
        {
            id: '/dashboard',
            description: 'Dashboard',
        },
        {
            id: '/listing',
            description: 'Inventory',
        },
        {
            id: '/listing/draft/open',
            description: 'DraftListing',
        },
        {
            id: '/member',
            description: 'Member & Item Lookup',
        },

        {
            id: '/invoice',
            description: 'All Invoices',
        },

        {
            id: '/buyers',
            description: 'Customers',
        },
        {
            id: '/org',
            description: 'Sellers',
        },

        {
            id: '/locations',
            description: 'Locations',
        },

        {
            id: '/seller_payout/transaction',
            description: 'Seller Payout Transaction',
        },
        {
            id: '/zb/zp_transaction',
            description: 'Zipperbuy Transaction',
        },
        {
            id: '/zb/zp/transfer',
            description: 'Zipperbuy Logs',
        },
        {
            id: '/seller_payout/manual',
            description: 'Seller Payout Manual',
        },
        {
            id: '/seller_payout/auto',
            description: 'Seller Payout Auto',
        },
        {
            id: '/registration_coupon',
            description: 'Coupons List',
        },
        {
            id: '/gift_card',
            description: 'Gift Cards',
        },
        {
            id: '/report',
            description: 'Report Management',
        },
        {
            id: '/syncinventory',
            description: 'Sync Inventory',
        },

        {
            id: '/communications/email',
            description: 'Email Template',
        },
        {
            id: '/communications/sms',
            description: 'SMS Template',
        },

        {
            id: '/communications/logs/emailLogs',
            description: 'Email Logs',
        },
        {
            id: '/communications/logs/smsLogs',
            description: 'SMS Logs',
        },
        {
            id: '/change_password',
            description: 'Change Password',
        },
        {
            id: '/settings/twoFactor',
            description: 'Two Factor Authentication',
        },
        {
            id: '/transaction/payment',
            description: 'Transactions Payment',
        },
        {
            id: '/questions_answers',
            description: 'Questions & Answers',
        },
    ]

    const allPermission = [
        '/dashboard',
        '/listing',
        '/buyers',
        '/org',
        '/org/rejected',
        'buyers/rejected',
        '/invoice',
        '/return',
        '/subscribers',
        '/logs/emailLogs',
        '/logs/smsLogs',
        '/communications/logs/emailLogs',
        '/communications/logs/smsLogs',
        '/settings/location',
        '/listing/draft/open',
        '/member',
        '/change_password',
        '/settings/twoFactor',
        '/questions_answers',
        '/locations',
        '/profile',
        '/transaction/payment',
    ]
    const [permissionSelect, setPermissionSelect] = useState(permission)
    const [selectPermission, setSelectPermission] = useState(allPermission)
    const [profile1, setProfile1] = useState([])
    const [profile2, setProfile2] = useState([])
    const [profile3, setProfile3] = useState([])

    const validationArray = Yup.object({
        emp_email: Yup.string()
            .email('Invalid email format')
            .required('Required!'),
        confirm_email:
            props?.match?.params?.status === 'new'
                ? Yup.string()
                      .email('Invalid email format')
                      .oneOf([Yup.ref('emp_email')], 'Email not match')
                      .required('Required!')
                : Yup.string(),
        emp_firstname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_lastname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_address1: Yup.string().required('Required!'),
        emp_phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        emp_type: Yup.string().required('Required!'),
        emp_city: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
            .required('Required'),
        emp_state: Yup.string().required('Required!'),
        emp_country: Yup.string().required('Required!'),
        emp_zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive number only')
            .max(6, 'Maximum 6 characters')
            .required('Required'),
        emp_permissions: Yup.array().required('Required!'),
        emp_location: Yup.array().required('Required!'),
    })

    const validationArrayPassword = Yup.object({
        password: Yup.string()
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must contain at least one lowercase letter, uppercase letter, number and special character'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required!'),
    })
    const [formikValues, setFormikValues] = useState(initialValues)

    const personalDetailsNew = [
        {
            label: 'First name *',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-sm-6 col-12',
            name: 'emp_firstname',
            autoFocus: true,
        },
        {
            label: 'Last Name *',
            placeholder: 'Enter last name',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_lastname',
        },
        {
            label: 'Phone Number *',
            placeholder: 'Enter phone number',
            type: 'phone',
            class: 'col-sm-6 col-12',
            name: 'emp_phone',
        },
        {
            label: 'Employee Type *',
            placeholder: 'Enter employee type',
            class: 'col-sm-6 col-12',
            type: 'select',
            options:
                user.emp_type === 'super_admin'
                    ? [
                          { value: 'super_admin', show: 'Super admin' },
                          { value: 'admin', show: 'Admin' },
                          { value: 'employee', show: 'Employee' },
                      ]
                    : [{ value: 'employee', show: 'Employee' }],
            name: 'emp_type',
        },
        {
            label: 'Employee Location *',
            placeholder: 'Select Employee Location',
            class: 'col-sm-6 col-12',
            type: 'multiselect',
            options: allLocations
                ?.filter((location) => location.active === 1)
                .map((location) => {
                    return {
                        value: String(location.id),
                        show: location.name,
                    }
                }),
            defaultOptionValue: 'Select Employee Location',
            name: 'emp_location',
        },
    ]

    personalDetailsNew.push(
        {
            label: 'Email Address *',
            placeholder: 'Enter email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_email',
        },
        {
            label: 'Confirm Email Address *',
            placeholder: 'Confirm your email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'confirm_email',
        }
    )

    const passwordChange = [
        {
            label: 'Password',
            placeholder: 'Enter Password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Re-Enter Password',
            placeholder: 'Re-Enter password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const locationDetails = [
        {
            label: 'Street Address *',
            placeholder: 'Enter street address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_address1',
        },
        {
            label: 'Country *',
            placeholder: 'Select country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_country',
        },
        {
            label: 'State *',
            placeholder: 'Select state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formikValues.emp_country
                            ? formikValues.emp_country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_state',
        },
        {
            label: 'City *',
            placeholder: 'Enter city',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_city',
        },
        {
            label: 'ZIP *',
            placeholder: 'Enter ZIP',
            type: 'number',
            class: 'col-sm-6 col-12',
            name: 'emp_zip',
        },
    ]

    useEffect(() => {
        if (formikValues.emp_type === 'super_admin') {
            permission.push(
                {
                    id: '/employees/all',
                    description: 'All Employees',
                },
                {
                    id: '/settings/static',
                    description: 'Static Pages',
                },
                {
                    id: '/settings/general',
                    description: 'General Settings',
                },
                {
                    id: '/settings/headermenus',
                    description: 'Header Menus',
                },
                {
                    id: '/settings/maintanence',
                    description: 'Maintanence',
                },
                {
                    id: '/settings/banner',
                    description: 'Banner Image',
                },
                {
                    id: '/settings/category',
                    description: 'Category',
                },
                {
                    id: '/settings/condition',
                    description: 'Condition',
                },
                {
                    id: '/settings/location',
                    description: 'Location',
                },

                {
                    id: '/settings/bid_increments',
                    description: 'Offer Increments',
                },
                {
                    id: '/subscribers',
                    description: 'Subscribers',
                },
                {
                    id: '/profile',
                    description: 'Profile',
                }
            )
            allPermission.push(
                '/employees/all',
                '/settings/bid_increments',
                '/settings/category',
                '/settings/condition',
                '/settings/banner',
                '/settings/maintanence',
                '/settings/general',
                '/settings/static',
                '/settings/headermenus',
                '/seller_payout/transaction',
                '/zb/zp/transfer',
                '/zb/zp_transaction',
                '/seller_payout/manual',
                '/seller_payout/auto',
                '/registration_coupon',
                '/gift_card',
                '/communications/email',
                '/communications/sms',
                '/report',
                '/syncinventory',
                '/transaction/payment'
            )
            setSelectPermission(allPermission)
            setPermissionSelect(permission)
        } else if (formikValues.emp_type === 'admin') {
            permission.push({
                id: '/employees/all',
                description: 'All Employees',
            })
            allPermission.push('/employees/all')
            setSelectPermission(allPermission)
            setPermissionSelect(permission)
        } else {
            setPermissionSelect(permission)
        }
    }, [formikValues.emp_type])

    useEffect(() => {
        setFormikValues(initialValues)
    }, [initialValues])

    const permissionDetails = [
        {
            type: 'check',
            class: 'empPermissions d-flex align-items-center flex-wrap',
            name: 'emp_permissions',
            options: permissionSelect,
        },
    ]

    const selectDetails = [
        {
            type: 'radio',
            class: 'empPermissions d-flex align-items-center flex-wrap',
            name: 'select_all',
            options: [
                {
                    id: '/all',
                    description: 'Select All',
                },
                {
                    id: '/none',
                    description: 'Select None',
                },
                {
                    id: '/profile1',
                    description: 'Profile 1',
                },
                {
                    id: '/profile2',
                    description: 'Profile 2',
                },
                {
                    id: '/profile3',
                    description: 'Profile 3',
                },
            ],
        },
    ]

    const formikValueUpdate = (value) => {
        setFormikValues(value)
    }

    const closeFunction = () => {
        resetFrom()
        history.goBack()
    }

    useEffect(() => {
        if (
            allConfigurationVariables?.emp_permissions_profile_1 &&
            allConfigurationVariables?.emp_permissions_profile_1?.split(',')
                ?.length
        ) {
            setProfile1(
                allConfigurationVariables?.emp_permissions_profile_1?.split(',')
            )
        }
    }, [allConfigurationVariables?.emp_permissions_profile_1])

    useEffect(() => {
        if (
            allConfigurationVariables?.emp_permissions_profile_2 &&
            allConfigurationVariables?.emp_permissions_profile_2?.split(',')
                ?.length
        ) {
            setProfile2(
                allConfigurationVariables?.emp_permissions_profile_2?.split(',')
            )
        }
    }, [allConfigurationVariables?.emp_permissions_profile_2])

    useEffect(() => {
        if (
            allConfigurationVariables?.emp_permissions_profile_3 &&
            allConfigurationVariables?.emp_permissions_profile_3?.split(',')
                ?.length
        ) {
            setProfile3(
                allConfigurationVariables?.emp_permissions_profile_3?.split(',')
            )
        }
    }, [allConfigurationVariables?.emp_permissions_profile_3])

    return (
        <EmployeeForm
            data={props?.data}
            isnotCustom={props?.data ? false : true}
            initialValues={initialValues}
            passwordInitialValues={passwordInitialValues}
            validationArray={validationArray}
            validationArrayPassword={validationArrayPassword}
            permissionDetails={permissionDetails}
            permissionSelect={selectPermission}
            locationDetails={locationDetails}
            passwordChange={passwordChange}
            personalDetailsNew={personalDetailsNew}
            toggleFullScreenPopup={props.function}
            formikValueUpdate={formikValueUpdate}
            employeeFunctionEdit={employeeFunctionEdit}
            resetFrom={resetFrom}
            custom={props?.custom}
            selectDetails={selectDetails}
            employeeId={
                props?.match?.params?.id
                    ? parseInt(props?.match?.params?.id)
                    : 0
            }
            employeeStatus={props?.match?.params?.status}
            closeFunction={closeFunction}
            profile1={[...profile1, '/org']}
            profile2={[...profile2, '/org']}
            profile3={[...profile3, '/org']}
            dynamicPermission={true}
        />
    )
}

export default EmployeeManage
